import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const BulletinBoardContainer = styled.div`
  display: flex;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
  font-family: 'Raleway', sans-serif;

  @media (max-width: ${screenSizes.tablet}) {
    flex-direction: column;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
  }

  .create-button-container {
    @media (max-width: ${screenSizes.mobile}) {
      bottom: 1rem;
      right: 1rem;

      button {
        font-size: 0.9rem;
        padding: 0.8rem 1rem;
      }
    }
  }
`;

export const Sidebar = styled.div`
  width: 300px;
  background-color: #1d1d1b;
  color: white;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #333;
  flex-shrink: 0;
  height: 100%;
  max-height: 100vh;

  @media (max-width: ${screenSizes.tablet}) {
    width: 100%;
    max-height: 200px;
    height: auto;
    border-right: none;
    border-bottom: 1px solid #333;
    flex-shrink: 0;
  }

  @media (max-width: ${screenSizes.mobile}) {
    max-height: 150px;
  }

  .sidebar-header {
    padding: 1.5rem;
    border-bottom: 1px solid #333;
    background-color: #242323;

    h2 {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 600;
      color: white;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 1.2rem;
      }
    }
  }

  .entries-list {
    list-style: none;
    padding: 0;
    margin: 0;

    .entry-item {
      border-bottom: 1px solid #333;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #2a2a2a;
      }

      &.active {
        background-color: #10d8b4;
        color: #1d1d1b;

        .entry-link {
          color: #1d1d1b;
          font-weight: 600;
        }
      }

      .entry-link {
        display: block;
        padding: 1rem 1.5rem;
        color: white;
        text-decoration: none;
        cursor: pointer;
        font-size: 0.95rem;
        line-height: 1.4;

        @media (max-width: ${screenSizes.mobile}) {
          padding: 0.75rem 1rem;
          font-size: 0.85rem;
        }

        .entry-title {
          font-weight: 500;
          margin-bottom: 0.25rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .read-indicator {
          display: inline-flex;
          align-items: center;
          gap: 0.25rem;
          padding: 0.2rem 0.5rem;
          background-color: rgba(16, 216, 180, 0.2);
          border-radius: 4px;
          font-size: 0.7rem;
          color: #10d8b4;
          font-weight: 600;
        }

        .entry-date {
          font-size: 0.8rem;
          opacity: 0.7;
          color: inherit;

          @media (max-width: ${screenSizes.mobile}) {
            font-size: 0.75rem;
          }
        }

        .entry-type {
          display: inline-block;
          margin-top: 0.5rem;
          padding: 0.25rem 0.5rem;
          background-color: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          font-size: 0.7rem;
          text-transform: uppercase;
        }
      }

      .entry-actions {
        display: flex;
        gap: 0.5rem;
        margin-top: 0.5rem;
        padding-top: 0.5rem;
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        button {
          flex: 1;
          padding: 0.4rem 0.6rem;
          font-size: 0.75rem;
        }
      }
    }
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  padding: 2rem;
  height: 100%;
  max-height: 100vh;
  min-height: 0;

  @media (max-width: ${screenSizes.tablet}) {
    padding: 1.5rem;
    height: auto;
    max-height: calc(100vh - 200px);
    min-height: calc(100vh - 200px);
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 1rem;
    max-height: calc(100vh - 150px);
    min-height: calc(100vh - 150px);
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
    text-align: center;

    h3 {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      color: #666;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 1.2rem;
      }
    }

    p {
      font-size: 1rem;
      color: #999;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 0.9rem;
      }
    }
  }

  .content-header {
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #e0e0e0;

    h1 {
      margin: 0 0 0.5rem 0;
      font-size: 2rem;
      color: #2c3e50;
      font-weight: 600;

      @media (max-width: ${screenSizes.tablet}) {
        font-size: 1.75rem;
      }

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 1.5rem;
      }
    }

    .content-meta {
      display: flex;
      gap: 1rem;
      font-size: 0.9rem;
      color: #666;
      flex-wrap: wrap;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 0.8rem;
        gap: 0.5rem;
      }

      .meta-item {
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }
    }
  }

  .text-content {
    line-height: 1.6;
    margin-bottom: 2rem;
    font-size: 1rem;
    color: #333;

    p {
      margin-bottom: 1rem;
    }

    img {
      max-width: 100%;
      height: auto;
      margin: 1rem 0;
      border-radius: 4px;
    }

    @media (max-width: ${screenSizes.tablet}) {
      font-size: 0.95rem;
      margin-bottom: 1.5rem;
    }

    @media (max-width: ${screenSizes.mobile}) {
      font-size: 0.9rem;
      margin-bottom: 1rem;
    }
  }

  .video-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    margin-bottom: 2rem;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    @media (max-width: ${screenSizes.tablet}) {
      margin-bottom: 1.5rem;
    }

    @media (max-width: ${screenSizes.mobile}) {
      margin-bottom: 1rem;
      touch-action: manipulation;

      .react-player {
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }

  .play-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.8);
      transform: translate(-50%, -50%) scale(1.1);
    }

    svg {
      width: 30px;
      height: 30px;
      margin-left: 5px;
    }

    @media (max-width: ${screenSizes.mobile}) {
      width: 60px;
      height: 60px;
      background: rgba(0, 0, 0, 0.8);
      backdrop-filter: blur(2px);

      svg {
        width: 25px;
        height: 25px;
        margin-left: 3px;
      }

      &:active {
        transform: translate(-50%, -50%) scale(0.95);
      }
    }
  }
`;
